module.exports = __webpack_public_path__ + "static/themes-change-do-915fd0572288a8d58e08ccf26ec785a8.png";